<template>
    <div class="billing-center-box">
        <van-nav-bar title="名单管理" />
        <van-tabs @click="onClick" color="#fe7b43">
            <van-tab name="2" title="全部"></van-tab>
            <van-tab name="1" title="已核销名单"></van-tab>
            <van-tab name="0" title="未核销名单"></van-tab>
        </van-tabs>
        <div class="hhk-content">
            <div class="hhk-item df" v-for="(item, index) in List" :key="index" @click="onGoEditPage(item)">
                <div class="left">
                    <div class="hhk-item-name">{{ item.boonName }}</div>
                    <div v-if="item.boonType == 1">券类型：商家优惠券</div>
                    <div v-if="item.boonType == 2">券类型：积分兑换券</div>
                    <!-- <div>原价：{{ item.nei }}</div> -->
                    <div>领取用户：{{ item.usersName }}</div>
                    <!-- <div>使用积分：{{ item.nei }}</div> -->
                    <div>领取时间：{{ item.createTime }}</div>
                    <div v-if="item.verificationCode">核销码：{{ item.verificationCode }}</div>
                    <div v-if="item.verificationTime">核销时间：{{ item.verificationTime }}</div>
                    <div v-if="item.verificationType == 1">核销方式：扫码验券</div>
                    <div v-if="item.verificationType == 2">核销方式：输码验券</div>
                    <div v-if="item.mallBranchStoreName">核销门店：{{ item.mallBranchStoreName }}</div>
                    <div v-if="item.businessUsersName">核销管理员：{{ item.businessUsersName }}</div>
                </div>
                <div class="right">
                    <div v-if="item.verificationState == 1">已核销</div>
                    <div v-if="item.verificationState == 0">未核销</div>
                </div>
            </div>
        </div>
        <!-- <div class="hhk-btn-box">
            <van-button type="default" color="#FF6633" block :to="{ path: '/add-or-edit-hhk', query: { isAdd: true } }">
                添加花惠卡折扣
            </van-button>
        </div> -->
    </div>
</template>

<script>
import moment from 'moment';
import { getMallBoonRosterByVerificationState } from '../api/index';
export default {
    data() {
        return {
            List: [],
            paramas: {
                mallBoonID: '',
                verificationState: '2'
            }
        };
    },
    mounted() {
        this.paramas.mallBoonID = this.$route.query.id;
        this.getMallBoonRosterByVerificationState();
    },
    methods: {
        getMallBoonRosterByVerificationState() {
            getMallBoonRosterByVerificationState(this.paramas).then((res) => {
                console.log(res.data);
                this.List = res.data;
                this.List.map((e) => {
                    e.createTime = moment(e.createTime).format('YYYY-MM-DD HH:mm:ss');
                });
            });
        },
        onClick(name, title) {
            this.paramas.verificationState = name;
            this.getMallBoonRosterByVerificationState();
        }
    }
};
</script>

<style scoped lang="scss">
.billing-center-box {
    height: 100vh;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;

    .hhk-content {
        flex: 1;
        border-top: 1px solid #eeeeee;
        overflow: auto;

        .hhk-item {
            padding: 15px 10px;
            font-size: 14px;
            align-items: center;
            border-bottom: 1px solid #eeeeee;
            background-color: #ffffff;

            .left {
                flex: 1;

                .hhk-item-name {
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
        .hhk-item:active {
            background-color: #eeeeee;
        }
    }

    .hhk-btn-box {
        padding: 10px 10px;
        background-color: #ffffff;
        border-top: 1px solid #eeeeee;

        .van-button {
            font-size: 16px;
        }
    }
}
</style>
